<template>
    <div>
        <b-button variant="default" @click="$bvModal.show(editModalId)">
            <font-awesome-icon :icon="['fas', 'pen-to-square']" />
        </b-button>
        <b-button variant="default" @click="$bvModal.show(deleteModalId)">
            <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
        <create-edit-review-modal
            :modalId="editModalId"
            :title="modalTitle"
            :initValues="initValues"
            @submit="onEdit"
        />
        <modal :id="deleteModalId" title="Delete Review" @ok.prevent="removeReview">
            Are you sure want to delete this review?
        </modal>
    </div>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';
import CreateEditReviewModal from './create-edit-review-modal.vue';
export default {
    components: {
        Modal,
        CreateEditReviewModal,
    },
    computed: {
        editModalId() {
            return 'edit-review-modal' + this.params.data.id;
        },
        deleteModalId() {
            return 'delete-review-modal' + this.params.data.id;
        },
        modalTitle() {
            return `Edit review (${this.params.language})`;
        },
        initValues() {
            return this.params.data;
        },
    },
    methods: {
        onEdit(values, modalId) {
            this.params.onSave(values, modalId);
        },
        removeReview() {
            this.params.onRemove(this.params.data.id, this.deleteModalId);
        },
    },
};
</script>

<style>
</style>